import { useEffect, useState } from 'react';
import { Button, Sheet } from '../../../ui';
import { copy } from '../copy';
import { FOCUS } from '../styles';

interface Props {
  open: boolean;
  onOpenChange(open: boolean): void;
  title: string;
  initial: number;
  /** Resolves to an error message, or null when saved. */
  onSave(count: number): Promise<string | null>;
}

/** "Write the day's count": the number entered becomes the day's count (spec §7). */
export function DayTotalSheet({ open, onOpenChange, title, initial, onSave }: Props) {
  const [text, setText] = useState(String(initial));
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (open) {
      setText(String(initial));
      setError(null);
    }
  }, [open, initial]);
  const value = Number.parseInt(text, 10);
  const n = Number.isNaN(value) ? 0 : value;
  const stepBtn = `inline-flex h-12 w-12 items-center justify-center rounded-full bg-secondary text-2xl text-fg disabled:opacity-40 ${FOCUS}`;

  return (
    <Sheet open={open} onOpenChange={onOpenChange} title={title} description={copy.totalHint}>
      <div className="flex items-center justify-center gap-4 py-4">
        <button
          type="button"
          aria-label={copy.oneLess}
          className={stepBtn}
          disabled={n <= 0}
          onClick={() => setText(String(Math.max(0, n - 1)))}
        >
          −
        </button>
        <input
          type="number"
          inputMode="numeric"
          min={0}
          max={200}
          aria-label={copy.cigarettes}
          value={text}
          onChange={(e) => setText(e.target.value)}
          className={`h-16 w-24 rounded-2xl border border-border bg-surface text-center font-mono text-4xl tabular-nums text-fg ${FOCUS}`}
        />
        <button
          type="button"
          aria-label={copy.oneMore}
          className={stepBtn}
          onClick={() => setText(String(n + 1))}
        >
          +
        </button>
      </div>
      {error ? (
        <p role="alert" className="pb-2 text-center text-sm text-destructive">
          {error}
        </p>
      ) : null}
      <Button
        variant="primary"
        block
        onClick={async () => {
          const message = await onSave(n);
          if (message) setError(message);
          else onOpenChange(false);
        }}
      >
        {copy.saveTotal}
      </Button>
    </Sheet>
  );
}
